import { render, staticRenderFns } from "./AvaliacaoStartups.vue?vue&type=template&id=633bbab9&scoped=true"
import script from "./AvaliacaoStartups.vue?vue&type=script&lang=js"
export * from "./AvaliacaoStartups.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoStartups.vue?vue&type=style&index=0&id=633bbab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633bbab9",
  null
  
)

export default component.exports